<template>
  <div
    class="marketing-category-card"
    :style="{
      'background-image': `url(${backgroundImageUrl})`,
      'background-size': 'cover',
    }"
    @click="$emit('input', type)"
  >
    <div
      class="qrw-heading-xs"
      :class="{
        'v1-grey-3-color': isSelected,
        'v1-grey-10-color': !isSelected,
      }"
    >
      {{ $t("marketing.tab_" + type) }}
    </div>

    <div
      class="qrw-paragraph-xs mt-8"
      :class="{
        'v1-grey-7-color': !isSelected,
        'v1-grey-6-color': isSelected,
      }"
    >
      {{ $t("marketing.desc_" + type) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    type: String,
  },
  methods: {},
  computed: {
    isSelected() {
      return this.value === this.type;
    },
    backgroundImageUrl() {
      return `/icons/marketing/${this.type}/${
        this.isSelected ? "selected" : "unselected"
      }.jpg`;
    },
  },
};
</script>

<style scoped>
.marketing-category-card {
  position: relative;

  min-width: 381px;
  max-width: 381px;

  border-radius: 8px;
  padding: 16px;

  cursor: pointer;
}
</style>